import React from 'react';

import styles from './StarsBadge.scss';

export interface Props {
  component: React.ComponentType;
}

const StarsBadge: React.FC<Props> = ({ component }) => (
  <span className={styles.badge}>{React.createElement(component)}</span>
);

export default StarsBadge;
